export default {
  header: 'Excise duty information',
  amountPaid: 'Amount paid',
  datePaid: 'Date paid',
  notPaid: 'Not paid',
  paymentReferenceId: 'Payment reference ID',
  na: 'N/A',
};
